/** Marks a `<details>` whose server-rendered state is open, so a client
 *  can restore `defaultOpen` after the reader has toggled it. */
export const DEFAULT_OPEN_ATTRIBUTE = "data-cl-default-open";
